import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ReactComponent as HassantukLogo } from "src/assets/icons/hassantuk-logo-header.svg";
import HorizontalDivider from "src/components/HorizontalDivider/HorizontalDivider";
import {
  convertDateIFNotMin,
  getTextValueById,
  isRtl,
} from "src/utils/helpers";
import InvoiceNotes from "../InvoiceNotes";

import InvoiceCompanyDetails from "../InvoiceCompanyDetails";
import ConsolidatedInvoiceList from "./ConsolidatedInvoiceList";

const ConsolidatedInvoicePrintView = () => {
  const { t } = useTranslation(["common", "registration", "invoice"]);
  const language = useSelector((state: any) => state.lookup.language);
  const {
    consolidatedInvoiceNumber,
    paymentDate,
    status
  } = useSelector(
    (state: any) => state.invoices?.consolidatedInvoiceDetailsPopupData
  );

  const { consolidatedInvoiceStatusOptions } = useSelector(
    (state: any) => state.lookup
  );
  return (
    <div
      className="pt-1 building-details-form print-view print-only"
      style={{ direction: isRtl(language) ? "rtl" : "ltr" }}
    >
      <div className="invoice-details d-flex flex-column">
        <section className="invoice-header">
          <div className="invoice-header__logos d-flex justify-content-between align-items-center mb-2">
            <HassantukLogo className="hassantuk" />
            <div className="invoice-header__details__title w-100 d-flex justify-content-center">
              <h6 className="text-center mt-3">
              {t("invoiceDetails.bmcConsolidatedPaymentInvoiceSummary")}
              </h6>
            </div>
          </div>
          <div className="invoice-header__details">
            <HorizontalDivider />
            <div className="invoice-header__details__info d-flex flex-column">
              <div className="invoice-header__details__info__row d-flex justify-content-between">
                <div className="invoice-header__details__info__row__item d-flex align-items-center pe-2 py-2 w-100">
                  <h6 className="w-50">{t("invoiceDetails.consolidatedInvoiceNumber")}</h6>
                  <span className="w-50">{consolidatedInvoiceNumber}</span>
                </div>
              </div>
              <HorizontalDivider />
              <div className="invoice-header__details__info__row d-flex justify-content-between">
                <div className="invoice-header__details__info__row__item d-flex align-items-center pe-2 py-2 w-100">
                  <h6 className="w-50">{t("invoiceDetails.paymentDate")}</h6>
                  <span className="w-50">
                    {" "}
                    {convertDateIFNotMin(paymentDate)}
                  </span>
                </div>
              </div>
              <HorizontalDivider />

              <div className="invoice-header__details__info__row d-flex justify-content-between">
                <div className="invoice-header__details__info__row__item d-flex align-items-center pe-2 py-2 w-100">
                  <h6 className="w-50">{t("paymentStatus")}</h6>
                  <span className="w-50">
                    {getTextValueById(
                      status,
                      consolidatedInvoiceStatusOptions,
                      "id"
                    )}
                  </span>
                </div>
              </div>
            </div>
            <HorizontalDivider />
          </div>
        </section>
        <InvoiceCompanyDetails />
        <ConsolidatedInvoiceList  showPayButton ={false}/>

        <InvoiceNotes />
      </div>
    </div>
  );
};

export default ConsolidatedInvoicePrintView;
